import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'localizedDate',
  pure: false,
  standalone: true,
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: any, pattern: string = 'mediumDate'): any {
    const currentLang = this.translateService.currentLang.indexOf('de-') === 0 ? 'de-DE' : 'en-US';
    const datePipe: DatePipe = new DatePipe(currentLang);
    return datePipe.transform(value, pattern);
  }
}
